export default __webpack_public_path__ + "static/media/automated-material-flow.ab39f03b.svg";